import {
  Table,
  TableBodyInfiniteScroll,
  TableHeader
} from '@library/components/table';
import type { FormattedMemberNotes } from '@library/types/members/memberNotes';
import { MEMBER_NOTES_HEADER } from '@bo-constants/member/memberNotes';
import { MemberNotesTableRow } from '@bo-components/members/memberNotes';
import { NoResults } from '@library/components/NoResults';
import { useMemo } from 'react';

export interface MemberNotesTableProps {
  currentPage: number;
  notes: FormattedMemberNotes | undefined;
  onCurrentPageChange: () => void;
  onDeleteNote: (id: string) => void;
  totalPages: number;
}

export const MemberNotesTable = ({
  currentPage,
  notes,
  onCurrentPageChange,
  onDeleteNote,
  totalPages
}: MemberNotesTableProps) => {
  const infiniteScrollProps = useMemo(
    () => ({
      dataLength: notes?.length ?? 0,
      hasMore: totalPages > currentPage,
      loader: <p>Loading...</p>,
      next: onCurrentPageChange
    }),
    [notes, currentPage, onCurrentPageChange, totalPages]
  );

  if (!notes?.length) {
    return (
      <NoResults
        className="m-0 w-full"
        dataTestId="no-member-notes-results"
        label="There are no notes for this member"
      />
    );
  }

  return (
    <Table className="border-soFresh-140 overflow-x-auto rounded-lg border p-0">
      <TableHeader headers={MEMBER_NOTES_HEADER} />
      <TableBodyInfiniteScroll
        bodyHeight="[calc(100vh-18rem)]"
        bodyMaxHeight="max-h-[calc(100vh-18rem)]"
        infiniteScrollProps={infiniteScrollProps}
        scrollId="MemberNotesTableBody"
      >
        {notes.map((note) => (
          <MemberNotesTableRow
            key={note.id}
            note={note}
            onDeleteNote={onDeleteNote}
          />
        ))}
      </TableBodyInfiniteScroll>
    </Table>
  );
};
